import type {ComponentExportStructure} from '@wix/document-services-types'
import {SUPPORTED_DATA_TYPES} from './constants'
import type {DecorationSingleComponentPluginFunction} from '../../types'

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    const type = component.data?.type
    if (!type || !SUPPORTED_DATA_TYPES.has(type)) {
        return
    }

    if (component.label) {
        component.data.label = component.label
        delete component.label
    }
}
